import { Lightbulb } from "@/components/icons"
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert"

type DefinitionAlertProps = {
  title: string
  description: string
}

export function DefinitionAlert({ title, description }: DefinitionAlertProps) {
  return (
    <Alert variant="definition">
      <Lightbulb className="text-foreground size-5 sm:size-7" />
      <AlertTitle className="text-lg font-bold sm:text-xl">{title}</AlertTitle>
      <AlertDescription className="text-base sm:text-lg">{description}</AlertDescription>
    </Alert>
  )
}
